var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", {
      staticClass: "h4",
      domProps: { innerHTML: _vm._s(_vm.financingMentions.title) },
    }),
    _vm._v(" "),
    _c("p", {
      staticClass: "mb-1",
      domProps: { innerHTML: _vm._s(_vm.financingMentions.text) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }